import type { UiPreferences } from 'store/services/settings/uiPreferencesApi';

export interface UiPreferencesReadState {
  data?: Pick<UiPreferences, 'hideCompleteTradeConfirmation'>;
  isLoading?: boolean;
  isError?: boolean;
}

/**
 * Whether Complete Trade shows the confirmation modal (Asana 1219704178739168).
 * The only way to skip it is a loaded preference that says so; while the
 * preferences are loading, after a failed read, or with no data at all, the
 * modal shows (fail safe, Decision 9). hasSeenTradeConfirmModal no longer gates.
 */
export const shouldShowCompleteTradeConfirmation = ({
  data,
  isLoading,
  isError,
}: UiPreferencesReadState): boolean => {
  if (isLoading || isError || !data) return true;
  return data.hideCompleteTradeConfirmation !== true;
};
